import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/config";
import { Reveal } from "@/components/Reveal";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-sandalt/60">
      <div className="absolute -right-24 top-0 h-72 w-72 rounded-full bg-sun/40 blur-3xl" />
      <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-aqua/25 blur-3xl" />
      <div className="relative mx-auto max-w-4xl px-6 py-24 text-center md:py-32">
        <Reveal>
          <h2 className="font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl md:text-6xl">
            Mais informação. <span className="italic text-brand">Mais respeito.</span>{" "}
            <span className="text-flame">Mais inclusão.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink sm:text-lg">
            O autismo não define uma pessoa — é apenas parte da sua história. Informação
            de qualidade ajuda a construir ambientes mais acessíveis, respeitosos e
            acolhedores para todos.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <button
            data-testid="final-cta-button"
            onClick={() => scrollToId("comprar")}
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-navy px-10 py-4 text-sm font-extrabold uppercase tracking-wide text-white transition-all duration-200 hover:scale-105 hover:bg-flame"
          >
            Quero conhecer o e-book
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
